import { FAQS } from "@/data/content";
import OrnamentalDivider from "@/components/OrnamentalDivider";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";

export default function FAQ() {
  return (
    <div data-testid="faq-page" className="max-w-3xl mx-auto px-6 lg:px-10 py-20">
      <div className="text-center">
        <div className="stamp">Frequently Asked</div>
        <h1 className="serif text-5xl md:text-6xl text-[#6E2638] mt-4">Answers, briefly.</h1>
      </div>
      <OrnamentalDivider />
      <Accordion type="single" collapsible className="mt-6">
        {FAQS.map((f, i) => (
          <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-item-${i}`} className="border-b border-[#E5D9C5]">
            <AccordionTrigger className="serif text-left text-lg text-[#6E2638] hover:no-underline">
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="text-[#1A1817]/85 leading-relaxed pt-2">
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
}
